<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JGh0lV/tc-custom/9781398473843.jpg?1726454432080" alt="This image is the cover for the book Secret Sons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Sons
      </h1>
      <p class="bookDescription body article font2">
        <p>Tom Carter’s life as a young and brilliant managing partner of a famous London art gallery was all about to change with one call – from an old friend, Stephanie Patterson. <br/>Tom knew he would have to put his playboy lifestyle on hold as he helped out his old friend. All he had to do was bring an old painting from London to Jerusalem without bringing any undue attention to himself or the painting. <br/>But luck was not on his side. Stephanie is kidnapped by terrorists looking for the painting, a priceless diamond goes missing and it’s splashed all over TV. Tom asks Jake, an ex-marine for help but things go from bad to worse as they soon find themselves being chased by Israeli Special Forces, ISIS terrorists, the London Metropolitan Police Force, and their boss. <br/>Tom faces corporate corruption and death at every corner but he must learn quickly how to survive and adapt if he stands any chance of saving Stephanie, his career and keeping the painting out of terrorist’s hands.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jamie Rybeck
      </h2>
      
      <p class="authorDescription body article">Jamie Rybeck is a first-time author who hails from Ireland, where he lives with his wife and three children. Secret Sons is an action-packed fiction novel that delves deep into the corporate world that Jamie has worked in for the past twenty years, transporting you to the four corners of the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?648b6b26